import { Component, OnInit } from '@angular/core';
import { Jobs } from '../../models/jobs.model';
import Swal from 'sweetalert2';
import { HttpService } from '../../services/http.service';
import { FunctionsService } from '../../services/functions.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Professions } from '../../models/professions.model';
import { Companies } from '../../models/companies.model';

@Component({
  selector: 'app-admin-job-list',
  templateUrl: './admin-job-list.component.html',
  styleUrls: ['./admin-job-list.component.scss']
})
export class AdminJobListComponent implements OnInit {
  jobList: Jobs[] = [];
  isLoading: boolean = true;
  professionList: Professions[] = [];
  searching: Boolean = false;
  country: string = "";
  profession: string = "";
  level_of_study: string = "";
  years_of_experience: string = "";
  currentPage: number = 1;
  totalPage: number = 1;
  arrayOfPage: number[] = [];
  companyID: number = 0;
  company: any;

  constructor(private httpService: HttpService, public functionsService: FunctionsService, private router: Router, private route: ActivatedRoute) {
    const param : any = this.route.snapshot.paramMap.get('companyID')
    this.companyID = parseInt(param);
  }

  ngOnInit(): void {
    localStorage.removeItem('jobEditing');
    this.getJobs(1);
    this.professionList = this.functionsService.getProfessionsList();

    if (localStorage.getItem('searchCriterea') && localStorage.getItem('searchCriterea') != undefined) {
      const formValue = JSON.parse(localStorage.getItem("searchCriterea") || "{}");
      
      this.country = formValue['country'];
      this.profession = formValue['profession'];
      this.level_of_study = formValue['level_of_study'];
      this.years_of_experience = formValue['years_of_experience'];
    }
  }
  
  getJobs(page: number) {
    this.searching = false;
    
    page = (page < 0) ? 1 : ((page > this.totalPage) ? this.totalPage : page);
    if (localStorage.getItem('adminJobList') && localStorage.getItem('adminJobList') != undefined) {
      let list = JSON.parse(localStorage.getItem("adminJobList") || "[]");

      this.jobList = this.generateListOfJob(list);
    }

    this.httpService.getJobs('All', page, 50).subscribe(
      (response: any) => {
        if (response.status == "success") {
          this.currentPage = response.data.currentPage;
          this.totalPage = (response.data.totalPage == 0) ? 1 : response.data.totalPage;
          this.arrayOfPage = [];
          const limit = (this.totalPage <= 5) ? this.totalPage : 5;
          for (let index = 1; index <= limit; index++) {
            this.arrayOfPage.push(index);
          }
          let list = response.data.list;
          localStorage.setItem('adminJobList', JSON.stringify(list));

          this.jobList = this.generateListOfJob(list);
          this.isLoading = false;
        }
      },
      (error: any) => {
        this.isLoading = false;
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Vérifier votre connexion puis réessayée.',
        })
      }
    );
  }

  generateListOfJob(list: any[]): Jobs[] {
    let jobList: Jobs[] = [];

    list.forEach((element: any) => {
      let job = new Jobs(element);
      
      if (this.companyID == 0) {
        jobList.push(job);
      } else if (job.getCompany()['id'] == this.companyID) {
        jobList.push(job);
      }
    });

    return jobList;
  }
  
  searchJob(page: number) {
    let formValue: any = {};
    formValue['country'] = this.country;
    formValue['profession'] = this.profession;
    formValue['level_of_study'] = this.level_of_study;
    formValue['years_of_experience'] = this.years_of_experience;
    formValue['status'] = 'All';
    
    if (this.country == "" && this.profession == "" && this.level_of_study == "" && this.years_of_experience == "") {
      undefined;
    } else {
      this.searching = true;
      
      localStorage.setItem('searchCriterea', JSON.stringify(formValue));
      
      this.isLoading = true;
      
      this.httpService.searchJob(formValue, page).subscribe(
        (response: any) => {
          if (response.status == "success") {
            this.currentPage = response.data.currentPage;
            this.totalPage = (response.data.totalPage == 0) ? 1 : response.data.totalPage;
            this.arrayOfPage = [];
            const limit = (this.totalPage <= 5) ? this.totalPage : 5;
            for (let index = 1; index <= limit; index++) {
              this.arrayOfPage.push(index);
            }
            let list = response.data.list;
            this.jobList = this.generateListOfJob(list);
            this.isLoading = false;
          }
        },
        (error: any) => {
          this.isLoading = false;
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Vérifier votre connexion puis réessayée.',
          })
        }
      );
    }
  }
  
  getProfessionByID(id: any) {
    for (let index = 0; index < this.professionList.length; index++) {
      const profession = this.professionList[index];
      
      if (profession.getId() == id) {
        return profession.getLibelle();
      }
      
    }
    
    return '';
  }
  
  getCompanyAcronymByID(id: any) {
    const companiesList = this.functionsService.getCompaniesList();
    
    for (let index = 0; index < companiesList.length; index++) {
      const company = companiesList[index];

      if (company.getId() == id) {
        return company.getAcronym();
      }

    }
    
    return '';
  }

}
